import {Palette} from 'hubbl-shared';
import styled from 'styled-components';

export const GradientPill = styled.span<{
  size?: 'small' | 'medium' | 'large' | 'mini';
  pressable?: boolean;
}>`
  display: inline-block;
  background: linear-gradient(
    135deg,
    ${Palette.primaryCherokee}20,
    ${Palette.primaryPadua}20
  );
  color: ${Palette.almostBlack};
  padding: 4px 8px;
  border-radius: 12px;
  font-size: ${props =>
    props.size === 'large'
      ? '15px'
      : props.size === 'medium'
        ? '13px'
        : props.size === 'mini'
          ? '10px'
          : '11px'};
  font-weight: 500;
  margin: 2px 4px 2px 0;
  border: 1px solid ${Palette.primaryCherokee}30;
  cursor: ${props => (props.pressable ? 'pointer' : 'default')};
  transition: all 0.2s ease;

  ${props =>
    props.pressable &&
    `
    &:hover {
      background: linear-gradient(
        135deg,
        ${Palette.primaryCherokee}30,
        ${Palette.primaryPadua}30
      );
      border-color: ${Palette.primaryCherokee}50;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
  `}
`;
